import type { CSSProperties } from 'react'
import type { ForecastState } from '../../types'
import { useTranslation } from '../../lib/i18n'

interface HeaderProps {
  state: ForecastState
}

export function Header({ state: _ }: HeaderProps) {
  const { t } = useTranslation()

  return (
    <div style={styles.root}>
      <span style={styles.title}>{t('app.title')}</span>
    </div>
  )
}

const styles: Record<string, CSSProperties> = {
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 0 8px',
  },
  title: {
    fontSize: 22,
    fontWeight: 700,
    color: 'var(--tg-theme-text-color, #000)',
  },
  badge: {
    borderRadius: 8,
    padding: '4px 10px',
    fontSize: 13,
    fontWeight: 600,
  },
}
